// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const RtaAvailability = () => ({
   replace: true,
   templateUrl: '/assets/rtaAvailability.html',
   controllerAs: 'vm',
   controller: RtaAvailabilityController,

   bindToController: {
      docs: '<',
      limitTo: '<',
      rtaLoaded: '<',
      contentTypeIcon: '<'
   }
})

// Short Explanation: every bib record has it's own ID, but a bib record might have more than one item (for example different volumes for a magazine, or multiple copies of a book)
// - so if there is talk about an 'item', it's a 'version' of the bib record - I think in library land they call this holdings (the description of the book) & items (the actual 'phsyical' item (book/cd/whatever) ).

class RtaAvailabilityController {
   $location: any
   $log: any
   $scope: any
   $timeout: any
   $uibModal: any
   $window: any
   allItems: any
   authentication: any
   availabilities: any
   availabilityService: any
   config: any
   doc: any
   docs: any
   formatProperty: any
   getAvailabilityStatus: any
   getStatusMessage: any
   getTranslatedDisplayString: any
   hasAvailabilities: any
   hasMultipleBibIds: any
   hasProperty: any
   hasRequestableStatus: any
   i18n: any
   isCheckingRequestability: any
   isLoggedIn: any
   isRequestable: any
   isSierraClient: any
   isSierraRTA: any
   limitItems: any
   limitTo: any
   loadingMessage: any
   openClickTrackLink: any
   openDetailPage: any
   provider: any
   requestAllowed: any
   requestButtonMessage: any
   rtaAvailabilityService: any
   rtaLoaded: any
   selectedBibId: any
   selectedItemId: any
   showAbbreviatedRTA: any
   showAllAvailabilities: any
   showCallNumberCol: any
   showLocationCol: any
   showLocations: any
   showLocationsColumnIsOn: any
   showVolume: any
   showYear: any
   sierraService: any
   status: any
   useItemId: any
   userCanChoose: any
   constructor($scope: any, $window: any, $timeout: any, rtaAvailabilityService: any, availabilityService: any, translationService: any, $location: any, authentication: any, $uibModal: any, config: any, sierraService: any) {
      this.removeLocalStorageItems = this.removeLocalStorageItems.bind(this)
      this.$scope = $scope
      this.$window = $window
      this.$timeout = $timeout
      this.rtaAvailabilityService = rtaAvailabilityService
      this.availabilityService = availabilityService
      this.$location = $location
      this.authentication = authentication
      this.$uibModal = $uibModal
      this.config = config
      this.sierraService = sierraService
      this.i18n = translationService

      this.isSierraClient = this.config.data.rtaAvailability.isSierraClient
      this.showAbbreviatedRTA = this.config.data.rtaAvailability.showAbbreviatedRTA
      this.showLocationsColumnIsOn = this.config.data.rtaAvailability.showLocationsColumn

      this.isLoggedIn = false
      this.isRequestable = this.rtaAvailabilityService.isRequestable
      this.formatProperty = this.rtaAvailabilityService.formatProperty
      this.getStatusMessage = this.rtaAvailabilityService.getStatusMessage
      this.getTranslatedDisplayString = this.rtaAvailabilityService.getTranslatedDisplayString
      this.hasProperty = this.rtaAvailabilityService.hasProperty
      this.getAvailabilityStatus = this.rtaAvailabilityService.getAvailabilityStatus

      this.openDetailPage = this.$scope.openDetailPage
      this.openClickTrackLink = this.$scope.openClickTrackLink
      this.loadingMessage = '<div class="loading" aria-label="{{::i18n.translations.LOADING}}"></div>' + this.i18n.translations.REQUEST_CHECK_ALLOWED
      this.requestButtonMessage = this.i18n.translations.REQUEST_RTA

      this.setDirectiveVariablesWithDefaultValues()
   }

   // this function is repeated in traAvailabilityDirective.ts, availabilityDirective.ts and resultsFeedDirective.ts - i tried to make this a gloabl 
   // function but ran into annoying infinite digest loops which would crash the UI.
   getCombinedContentTypes(doc: any) {
      if (!doc || !doc.content_type) return ''
      const types: string[] = []
      
      types.push(this.i18n.translate(doc.content_type))
      
      if (doc.additional_content_types && doc.additional_content_types.length > 0) {
         doc.additional_content_types.forEach((type: string) => {
            types.push(this.i18n.translate(type))
         })
      }
      
      return types.join(' / ')
   }

   $onChanges(changesObj: any) {
      if (changesObj.docs && !changesObj.docs.isFirstChange()) {
         this.setDirectiveVariablesWithDefaultValues()
         return this.prepareRTAAvailabilityInfoForRender()
      }
   }

   $onInit() {
      return this.prepareRTAAvailabilityInfoForRender()
   }

   // Put any defaults here that would need to be re-calculated from a default starting value if the docs changed
   setDirectiveVariablesWithDefaultValues() {
      this.status = null
      this.doc = null
      this.requestAllowed = true
      this.hasAvailabilities = false
      this.hasMultipleBibIds = false
    
      this.showVolume = false
      this.showYear = false
      this.showLocationCol = false
      this.showCallNumberCol = false
      this.userCanChoose = false
      this.useItemId = false
      this.showLocations = false
      this.showAllAvailabilities = false

      this.availabilities = []
      this.allItems = []
      this.selectedBibId = ''
      this.selectedItemId = ''

      return this.isSierraRTA = false // Sierra clients may have some physical records from another catalog.
   }

   prepareRTAAvailabilityInfoForRender() {
      if (!this.docs || !this.docs?.length) {
         return
      }

      // use first doc for attributes related to main button
      this.doc = this.docs[0].doc
      // store the first bibId, so code can check if multiple bibIds exist below
      let bibId = this.doc.external_document_id
    
      this.selectedBibId = this.$window.localStorage.getItem('summon_request_bibid')
      this.selectedItemId = this.$window.localStorage.getItem('summon_request_itemid')
      _.each(this.docs, (doc: any) => {
         this.rtaAvailabilityService.prepareRtaDoc(doc, this.isSierraClient)
         // check if different document external ids exist. If so, we can show in UI a radiobutton so the user can pick the one they want.
         if ((bibId !== doc.doc.external_document_id) && this.isSierraClient) {
            this.hasMultipleBibIds = true
         }
    
         bibId = doc.doc.external_document_id
         // in case of merged records (multiple bibIds) combine all availabilities as if it's one record (which it is in the resultlist)
         return this.availabilities = this.availabilities.concat(doc.availabilities)
      })

      if (!this.availabilities?.length) {
         return
      }

      this.$scope.$watch('vm.selectedItemId', (newData: any, oldData: any) => {
         // this enables the request button when there is a volume selected
         return this.requestAllowed = !this.userCanChoose || newData
      }
      ,
      true
      )
      if (_.any(this.docs, (doc: any) => doc.doc.external_document_id === this.selectedBibId)) {
         this.toggleLocations()
         this.$timeout(() => {
            if (this.authentication.isLoggedIn(this.sierraService.provider)) {
               return this.requestItem()
            }
         }
         , 200)
      } else {
         this.selectedBibId = this.doc.external_document_id
      }
      this.availabilities =  _.sortBy(this.availabilities, this.rtaAvailabilityService.statusSort)

      // this combines similar items into 1 so we don't have to display multiple rows of items with same location, status, callno and volume
      // example record in SvS test data: "Between the devil & the deep blue bay: the struggle to save San Francisco Bay" - has 2 grouped and 2 other separate (3 rows in table)
      // so @allItems is an array of arrays, for gropued items the second array will contain more than 1 item, but most of the time, the second array just has 1 item
      this.allItems = _.chain(this.availabilities)
         .filter((item: any) => item && !item.isSuppressed) // sometimes an availability == null, filter those, and also suppressed items
         .groupBy((item: any) => `${item.location}_${item.statusMessage}_${item.callNumber}_${item.volume}}`)
         .map((group: any, idx: any) => this.rtaAvailabilityService.sanitizeAvailabilities(group, this.isSierraClient))
         .value()

      if (this.selectedItemId) {
      // the @allItems is a nested array, so a double _.find needed here
         const existingAvailItem = _.find(this.allItems, (availItem: any) => _.find(availItem, (ai: any) => ai.itemId === this.selectedItemId))
        
         if (existingAvailItem) {
            // and show all availabilities
            this.showAllAvailabilities = false
            this.toggleShowAllAvailabilities()
            this.toggleLocations(true)
         }
      }

      return this.initAvailabilities(this.availabilities)
   }

   initAvailabilities(availabilities: any) {
      this.showVolume = this.rtaAvailabilityService.hasVolume(availabilities)
      this.showYear = this.rtaAvailabilityService.hasYear(availabilities)
      this.showLocationCol = this.rtaAvailabilityService.hasLocation(availabilities) && this.showLocationsColumnIsOn
      this.showCallNumberCol = this.rtaAvailabilityService.hasCallNumber(availabilities)
      this.userCanChoose = (availabilities.length > 1) && (this.showVolume || this.hasMultipleBibIds)
      this.useItemId = this.showVolume || this.requestLevelIsItem()
      if (!this.userCanChoose && this.useItemId) { // if user cannot select and we must use item id, set default 'selectedItemId'
         this.selectedItemId = availabilities[0].itemId
      }
      this.status = this.rtaAvailabilityService.getStatusForAvailabilities(availabilities)
      this.isSierraRTA = this.isSierraClient && ((this.status.code !== 'unknown') || (availabilities.length > 1))
      this.hasRequestableStatus = this.rtaAvailabilityService.isRequestableForAvailabilities(availabilities)
      this.isLoggedIn = this.authentication.isLoggedIn(this.sierraService.provider)
      if (!this.hasRequestableStatus) {
         this.requestButtonMessage = this.i18n.translations.REQUEST_NOT_ALLOWED
      }
      this.hasAvailabilities = _.some(availabilities)
      return this.requestAllowed = !this.rtaAvailabilityService.hasVolume(availabilities) || this.selectedItemId
   }

   requestLevelIsItem() {
      const userInfo = this.sierraService.getLoadedUserInfo()
      if(!userInfo) return false 
      const itemConfigObjectHasKeys = userInfo.holdConfig?.item && Object.keys(userInfo.holdConfig?.item).length
      const bibConfigObjectHasKeys = userInfo.holdConfig?.bib && Object.keys(userInfo.holdConfig?.bib).length
      return itemConfigObjectHasKeys && !bibConfigObjectHasKeys
   }

   getMainDisplayInfo() {
      if (_.includes(['ai','citation'], this.availabilities[0].type)) {
         return this.availabilities[0].statusMessage
      }
      if (!this.showAbbreviatedRTA && this.availabilities[0].displayString.length) {
         return this.rtaAvailabilityService.getTranslatedDisplayString(this.availabilities[0])
      }
      return this.status.translation
   }

   toggleShowAllAvailabilities() {
      this.showAllAvailabilities = !this.showAllAvailabilities
      return this.limitItems = this.showAllAvailabilities ? this.availabilities.length : this.limitTo
   }

   handleClick(avDocs: any, event: any, index = 0) {
      if (this.isSierraRTA) {
         return
      }

      event.preventDefault()
      if (this.isExternalLink(avDocs)) {
         return this.openClickTrackLink(avDocs[0].link, avDocs[0])
      } else {
         return this.openDetailPage(this.docs[index].doc)
      }
   }

   handleClickOnSpace(avDocs: any, event: any, index = 0) {
      // Space does not trigger a native click on the anchor, so handle it here.
      // Enter is handled by the global keyup handler which triggers a click.
      if (event.which === 32) {
         return this.handleClick(avDocs, event, index)
      }
   }

   isExternalLink(avDocs: any) {
      return !this.isSierraRTA && (((avDocs[0].type !== 'ai') && (!this.doc.hasDetailPage || (avDocs[0].type !== 'rta'))) || this.$scope.onDetailPage)
   }

   rowIsClickable(doc: any) {
      if (!this.$scope.onDetailPage || this.isSierraRTA) {
         return !this.isSierraRTA
      }
      return doc.type !== 'ai'
   }

   removeLocalStorageItems() {
      this.$window.localStorage.removeItem('summon_request_bibid')
      return this.$window.localStorage.removeItem('summon_request_itemid')
   }

   selectAvailItem(availability: any) {
      if (!this.userCanChoose) { return } 
      this.isLoggedIn = this.authentication.isLoggedIn(this.sierraService.provider)
      // the @allItems is a nested array, so a double _.find needed here
      const existingAvailItem = _.find(this.allItems, (availItem: any) => _.find(availItem, (ai: any) => ai.itemId === this.selectedItemId))
      
      if (existingAvailItem) {
      // and show all availabilities
         this.selectedBibId = existingAvailItem[0].bibId
         const newDoc = _.find(this.docs, (doc: any) => doc.doc.external_document_id === this.selectedBibId)
         this.doc = newDoc.doc
         this.$window.localStorage.setItem('summon_request_bibid', this.selectedBibId)
      }

      // TODO determine if setting localstorage is needed (i think only needed for auth=redirect, when loading results after redirect we can continue the request)
      this.$window.localStorage.setItem('summon_request_itemid', this.selectedItemId)
    
      if (this.hasMultipleBibIds && this.isLoggedIn) {
         return this.checkWithSierraForRequestability() // enable or disable the request button
      }
   }

   toggleLocations(toggleTo = !this.showLocations) {
      this.isLoggedIn = this.authentication.isLoggedIn(this.sierraService.provider)
      this.isCheckingRequestability = false
      this.showLocations = toggleTo
      if (this.showLocations) {
         if (this.hasRequestableStatus && this.isLoggedIn && !this.hasMultipleBibIds) { // in case of hasMultipleBibIds, the check is done on item-select
            return this.checkWithSierraForRequestability()
         }
      } else {
      // if user collapses things again, we don't need to store the item info - only really needed for redirect login
         return this.removeLocalStorageItems()
      }
   }

   reloadAvailability() {
      this.rtaLoaded.loaded = false
      const saved = false
      const cache = false
      return this.availabilityService.getSingleDocRTA(this.doc, saved, cache)
   }

   requestItem() {
      // open request_item dialog
      if (this.authentication.isLoggedIn(this.sierraService.provider)) {
      // we're logged in, so don't need the localstorage anymore (was needed to show the right item after a redirect login)
         this.removeLocalStorageItems()
         // now open the request modal
         return this.$uibModal.open({
            templateUrl: '/assets/rtaAvailabilityRequest.html',
            controller: 'rtaAvailabilityRequestController',
            controllerAs: 'vm',
            resolve: {
               doc: () => this.doc,
               availabilities: () => this.availabilities,
               itemId: () => this.selectedItemId,
               useItemId: () => this.useItemId
            },
            backdrop: true,
            keyboard: true
         })
      } else {
         this.authentication.openLoginDialog('sierra')
            .then(() => {
               this.$log.debug('after login')
            }).catch(() => {
               this.isLoggedIn = this.authentication.isLoggedIn(this.sierraService.provider)
               if (this.isLoggedIn && !this.hasMultipleBibIds) {
                  this.sierraService.patronInfoLoadedPromise.promise
                     .then(() => {
                        this.checkWithSierraForRequestability().then((requestable: boolean) => {
                           if(requestable) {
                              this.requestItem()
                           }
                        })
                     })
               }
            })
      }
   }

   checkWithSierraForRequestability() {
      this.isCheckingRequestability = true
      this.requestButtonMessage = this.loadingMessage
      const bibId = this.sierraService.transformBibId(this.selectedBibId)
      return this.sierraService.getHoldRequestByBibId(bibId)
         .catch((requestResponse: any) => {
            if (requestResponse.data.code === 132) {
               this.requestButtonMessage = this.i18n.translations.REQUEST_NOT_ALLOWED
               this.hasRequestableStatus = false
            }
            return false
         }).then((success: any) => {
            if (success) {
               this.requestButtonMessage = this.i18n.translations.REQUEST_RTA
               return true
            }
            return false
         }).finally(() => { 
            return this.isCheckingRequestability = false
         })
   }
}

class RtaAvailabilityRequestController {
   $filter: any
   $log: any
   $q: any
   $uibModalInstance: any
   $window: any
   alerts: any
   authentication: any
   availabilities: any
   bibId: any
   cancelDate: any
   cancelDateAllowed: any
   cancelDateOptions: any
   configService: any
   doc: any
   hasError: any
   holdNote: any
   i18n: any
   isCancelDatePickerOpen: any
   isLoading: any
   itemId: any
   pickupLocations: any
   provider: any
   recordType: any
   rtaAvailabilityService: any
   selectedPickupLocation: any
   showMode: any
   showOptionalFields: any
   sierraService: any
   useItemId: any
   userIsAuthenticated: any
   constructor($window: any, $q: any, $uibModalInstance: any, rtaAvailabilityService: any, sierraService: any, configService: any, translationService: any, authenticationService: any, alertService: any, doc: any, availabilities: any, itemId: any, useItemId: any, $log: any, $filter: any) {
      this.$onInit = this.$onInit.bind(this)
      this.afterClose = this.afterClose.bind(this)
      this.loadDialogContent = this.loadDialogContent.bind(this)
      this.handleError = this.handleError.bind(this)
      this.login = this.login.bind(this)
      this.$window = $window
      this.$q = $q
      this.$uibModalInstance = $uibModalInstance
      this.rtaAvailabilityService = rtaAvailabilityService
      this.sierraService = sierraService
      this.configService = configService
      this.doc = doc
      this.availabilities = availabilities
      this.itemId = itemId
      this.useItemId = useItemId
      this.$log = $log
      this.$filter = $filter
      this.i18n = translationService
      this.alerts = alertService
      this.provider = this.sierraService.provider
      this.userIsAuthenticated = authenticationService.isLoggedIn(this.provider)
      this.isLoading = false
      this.pickupLocations = []
      this.selectedPickupLocation = ''
      this.showOptionalFields = false
      this.cancelDate = null
      this.holdNote = null
      this.cancelDateAllowed = false
      this.isCancelDatePickerOpen = false
      this.cancelDateOptions = 
      {minDate: new Date()}
    
      this.bibId = this.sierraService.transformBibId(this.doc.external_document_id)
      // Default to bib
      this.recordType = 'b'
      this.showMode = 'FORM'
      this.hasError = false
   }

   $onInit() {
      this.isLoading = true
      this.alerts.resetAlert('requestHoldError')
      this.alerts.resetAlert('requestHoldSuccess')
    
      this.$uibModalInstance.result.then((data: any) => { 
         //modal closed
         return this.afterClose(data)
      }).catch((data: any) => { 
         //modal dismissed
         return this.afterClose(data)
      })

      if (this.userIsAuthenticated) {
         return this.loadDialogContent()
      } else {
         return this.hasError = false
      }
   }

   afterClose(reason: any) {
      this.$log.debug('rta Dialog closed', reason)
      this.alerts.resetAlert('requestHoldError')
      return this.alerts.resetAlert('requestHoldSuccess')
   }

   loadDialogContent() {
      return this.sierraService.getHoldRequestByBibId(this.bibId)
         .then((requestResponse: any) => {
            const bibOrItem = this.useItemId ? 'item' : 'bib'
            const userInfo = this.sierraService.getLoadedUserInfo()            
                    
            if (requestResponse.data.holdshelf && !(userInfo.holdConfig?.[bibOrItem]?.useHomePickupLocation || userInfo.holdConfig?.[bibOrItem]?.useItemPickupLocation)) {
               this.pickupLocations = requestResponse.data.holdshelf.locations
               if (requestResponse.data.holdshelf.selected) {
                  this.pickupLocations.unshift(requestResponse.data.holdshelf.selected)
                  this.selectedPickupLocation = requestResponse.data.holdshelf.selected
               }
               // pick only option for patron without showing options if it's the only option
               if (this.pickupLocations.length === 1) {
                  this.selectedPickupLocation = this.pickupLocations[0]
                  this.pickupLocations = []
               }
            } else {
               // default: use home if exists, otherwise allow sierra api to handle selection
               this.selectedPickupLocation = { name: '', code: userInfo.libraryInfo.locationId || 'default' } 
               if (userInfo.holdConfig?.[bibOrItem]?.useHomePickupLocation && userInfo.libraryInfo.locationId) {
                  this.selectedPickupLocation = { name: userInfo.libraryInfo.locationName, code: userInfo.libraryInfo.locationId} 
               } else if (userInfo.holdConfig?.[bibOrItem]?.useItemPickupLocation) { 
                  this.sierraService.getItemByItemId(this.bibId)
                     .then((itemResp: any) => {
                        if (itemResp.data.entries[0].location) {
                           return this.selectedPickupLocation = itemResp.data.entries[0].location
                        }
                     // @ts-expect-error TS(2304) FIXME: Cannot find name 'err'.
                     }).catch(err)(() => { return this.selectedPickupLocation = { name: '', code: 'default' } })
               }
            }

            if (this.sierraService.userInfo.holdConfig?.[bibOrItem]?.notNeededAfter) {
               this.cancelDateAllowed = true
            }

            return this.isLoading = false
         }).catch(this.handleError)
   }

   handleError(error: any) {
      let msg
      this.showMode = 'SUMMARY'
      this.hasError = true
      this.isLoading = false

      if (error.data && error.data.description) {
         msg = error.data.description.replace('XCirc error :', '')
      } else if (error.data && error.data.msg) {
         msg = error.data.msg.replace('XCirc error :', '')
      } else {
         msg = this.i18n.translate(this.i18n.translations.REQUEST_ERROR_UNKNOWN)
      }
      return this.alerts.setAlert('requestHoldError', this.i18n.translate(this.i18n.translations.REQUEST_HOLD_FAILED, {reason: msg }))
   }

   login($event: any, provider = 'cas') {
      $event.preventDefault()
      // this redirects to the auth login
      return this.authentication.login('sierra', provider)
   }

   openCancelDatePicker() {
      return this.isCancelDatePickerOpen = true
   }

   cancel() {
      return this.$uibModalInstance.dismiss('cancel')
   }

   request(isValid: any) {
      if (isValid) {
         this.isLoading = true

         const hold = {
            recordType: this.useItemId ? 'i' : 'b',
            recordNumber: this.useItemId ? parseInt(this.itemId) : parseInt(this.bibId),
            pickupLocation: this.selectedPickupLocation?.code?.trim()
         }
         if (this.holdNote) {
            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            hold['note'] = this.holdNote
         }
         if (this.cancelDate) {
            // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            hold['neededBy'] = this.$filter('date')(this.cancelDate, 'yyyy-MM-dd')
         }

         return this.sierraService
            .createHoldRequest(hold, this.bibId)
            .then((data: any) => {
               this.showMode = 'SUMMARY'
               this.isLoading = false
               return this.alerts.setAlert('requestHoldSuccess', this.i18n.translations.REQUEST_HOLD_CREATED)
            })
            .catch(this.handleError)
      }
   }
}

RtaAvailabilityController.$inject = ['$scope', '$window', '$timeout', 'rtaAvailabilityService', 'availabilityService' ,'translationService', '$location', 'authenticationService', '$uibModal', 'configService', 'sierraService']

RtaAvailabilityRequestController.$inject = ['$window', '$q', '$uibModalInstance', 'rtaAvailabilityService', 'sierraService', 'configService', 'translationService', 'authenticationService', 'alertService', 'doc', 'availabilities', 'itemId', 'useItemId', '$log', '$filter']

angular.module('summonApp.directives')
   .controller('rtaAvailabilityRequestController', RtaAvailabilityRequestController)
   .controller('rtaAvailabilityController', RtaAvailabilityController)
   .directive('rtaAvailability', RtaAvailability)

